// extracted by mini-css-extract-plugin
export default {"container":"assetLabel_container__+eoWw","symbol":"assetLabel_symbol__A1pVD","icon":"assetLabel_icon__oCWyh","sep":"assetLabel_sep__tFWcl"};